export default __webpack_public_path__ + "static/media/weeztarget-no-icon.2498ed5c.png";